import { render, staticRenderFns } from "./EmissionsConnectionsList.vue?vue&type=template&id=db990780"
import script from "./EmissionsConnectionsList.vue?vue&type=script&lang=js"
export * from "./EmissionsConnectionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports